import TutorialsPanel from "./TutorialsPanel";

export default function TutorialsPage() {
    return <TutorialsPanel />;
}